module.exports = __webpack_public_path__ + "media/images/play video-71076149ec6fcbffff966a81db9910ed.svg";